import React, { useState } from 'react';
import { logError } from '../utilities';
import { ToastContainer, toast } from 'react-toastify';
import { trackShipments } from '../api/trackShipmentApi';
import { TrackShipmentQueryResponse } from '../apiModels/trackShipmentQueryResponse';
import GenericDataTable from './GenericDataTable';
import TrackShipmentResultTableRowFormatter from './TrackShipmentResultTableRowFormatter';
import ContainerPadded from './ContainerPadded';
import ProofOfDeliveryRequestModal from './ProofOfDeliveryRequestModal';
import TrackShipmentResultSet from './TrackShipmentResultSet';

export default function TrackShipment() {
    const notifyUserOfError = (err: string) => toast(err, { type: 'error' });
    const notifyUserOfSuccess = (msg: string) => toast(msg, { type: 'success' });

    const [trackingNumbers, setTrackingNumbers] = useState<string>();
    const [submittingForm, setSubmittingForm] = useState<boolean>(false);
    const [trackingResponses, setTrackingResponses] = useState<TrackShipmentQueryResponse[] | null>(null);

    const resetForm = () => {
        setTrackingNumbers('');
    };

    const submitForm = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setSubmittingForm(true);

        const trackingNumberArray = trackingNumbers?.split('\n');

        try {
            if (trackingNumberArray === undefined || trackingNumberArray === null || trackingNumberArray.length === 0) {
                notifyUserOfError('At least one tracking number is required.');
            }

            else {
                const responses = await trackShipments(trackingNumberArray);

                setTrackingResponses(responses);
                setSubmittingForm(false);
                resetForm();
            }
        }
        catch (error: any) {
            if (error instanceof Error) {
                notifyUserOfError(error.message);
            }

            logError(error);

            setSubmittingForm(false);
        }
        finally {
            // It is important to always return false to prevent the form from submitting.
            return false;
        }
    };

    return (
        <ContainerPadded>
            <form onSubmit={submitForm}>
                <div className='row'>
                    <div className='col-4'>
                        <h1>Track a Shipment</h1>
                        <p>Use this tool to track your shipment and request proof of delivery.</p>
                    </div>
                    <div className='col-8'>
                        <div className="mb-3">
                            <label htmlFor="tracking-numbers" className="form-label fw-bold">
                                Enter tracking number to track shipments.
                                <br />
                                <small>List one tracking number on each line.</small>
                            </label>
                            <textarea className="form-control"
                                name="tracking-numbers"
                                rows={3}
                                value={trackingNumbers}
                                required={true}
                                maxLength={5000}
                                placeholder="Enter at least one tracking number"
                                onChange={(e) => setTrackingNumbers(e.target.value)}></textarea>
                        </div>

                        <button className="btn btn-primary" disabled={submittingForm}>{submittingForm ? <span>Submitting</span> : <span>Submit</span>}</button>
                    </div>
                </div>
                <div className='row'>
                    {trackingResponses !== null && trackingResponses.length > 0 &&
                        <>
                            <div className='col-12'>
                                <h3>Results</h3>
                            </div>

                            {trackingResponses.map(tr =>
                                <TrackShipmentResultSet key={tr.trackingNumber}
                                    shipment={tr}
                                    submittingForm={submittingForm} />
                            )}
                        </>
                    }
                </div>
                <ToastContainer />
            </form>
        </ContainerPadded>
    );
}
